


















import { round as lodashRound } from 'lodash-es'

export default {
  filters: {
    lodashRound,
  },
  props: {
    progress: {
      type: Number,
      required: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '#aaa',
    },
    max: {
      type: Number,
      default: 100,
    },
    min: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    adjustedMax() {
      return Math.max(this.max, this.progress)
    },
    limitedProgress() {
      return Math.min(Math.max(0, this.progress), this.adjustedMax)
    },
    calculatedWidth() {
      return Math.max((this.limitedProgress / this.adjustedMax) * 100, this.min)
    },
  },
}
